import React from "react"
import PointsList from "./components/pointsList"

// Comps
import MyPointsHead from "../../components/MyPointsHead"

function MyPoints() {
  return (
    <>
      <MyPointsHead />
      <div className="my-points-body">
        <PointsList />
      </div>
    </>
  )
}

export default MyPoints
